import { store } from 'flow/configure-store';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { State } from 'flow/types/State';

export const isBundleCustomer = (extensionKey: ExtensionKey) => {
    const state = store.getState() as State;

    return state.customer.getIn([extensionKey, 'productType']) === 'bundle';
};
